import { put, debounce } from 'redux-saga/effects';
import {
  SELECTED_POPOVER_TYPES,
  selectedPopoverActions,
} from '../selectedPopover';

function* handleOptimizedPopoverSetPosition({ payload }) {
  yield put(selectedPopoverActions.setOptimizedPosition(payload));
}

const DEFAULT_VAL = 250;
const fromParams = Number(
  location.hash.replace('#debounce=', '') || DEFAULT_VAL,
);
const DEBOUNCE_VALUE = isNaN(fromParams) ? DEFAULT_VAL : fromParams;

export default function* popverHoverSaga() {
  yield debounce(
    DEBOUNCE_VALUE,
    SELECTED_POPOVER_TYPES.SET_POSITION,
    handleOptimizedPopoverSetPosition,
  );
}



// WEBPACK FOOTER //
// ./src/redux/schedule/sagas/popover-hover-saga.js